"use client";
import React from "react";
import { Routes, Route } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";
import Pricing from "../components/PricingPlanss/PricingPlans";

import Login from "../components/Login/LoginForm";
import Signup from "../components/SignnUp/SignUp";
import ForgotPassword from "../components/Login/ForgotPassword";
import ResetPassword from "../components/Login/ResetPassword";
import Verification from "../components/Login/Veriication";

function Pagges() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="login" element={<Login />} />         
        <Route path="signup" element={<Signup />} />   
        <Route path="forgot" element={<ForgotPassword />} /> 
        <Route path="reset" element={<ResetPassword />} />   
        <Route path="verify" element={<Verification />} />  
        <Route path="Pricing" element={<Pricing/>} />  
          <Route path="Pricing" element={<Pricing/>} />   
      </Routes>

      <Footer />
    </>
  );
}

export default Pagges;
